import styled from "styled-components";
import {useState} from "react";
import {useRouter} from "next/router";
import {useMessages} from "../hooks/useMessages";
import Button from "./Button";
import Icon from "./Icon";

const Box = styled.div`
  ul {
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    li {
      list-style: none;
      button {
        padding: 10px;
      }
    }
  }
`

const SocialShare = () => {
  const router = useRouter()
  const [shareUrl, setShareUrl] = useState(window.origin + router.asPath)
  const messagesQuery = useMessages()

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`)
  }

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/share?url=${shareUrl}`)
  }

  const handleWhatsappShare = () => {
    window.open(`https://api.whatsapp.com/send?text=${shareUrl}`)
  }

  const handleMailShare = () => {
    if (messagesQuery.data) {
      const url = encodeURI(`mailto:?subject=${messagesQuery.data.messages["share-site-mail-subject"]}&body=${shareUrl}`)
      window.open(url)
    }
  }

  return (
    <Box>
      <ul>
        <li>
          <Button variant={"transparent"}
                  onClick={handleFacebookShare}>
            <Icon variant="medium">facebook-line</Icon>
          </Button>
        </li>
        <li>
          <Button variant={"transparent"}
                  onClick={handleTwitterShare}>
            <Icon variant="medium">twitter-logo</Icon>
          </Button>
        </li>
        <li>
          <Button variant={"transparent"}
                  onClick={handleWhatsappShare}>
            <Icon variant="medium">whatsapp-line</Icon>
          </Button>
        </li>
        <li>
          <Button variant={"transparent"}
                  onClick={handleMailShare}>
            <Icon variant="medium">mail-line</Icon>
          </Button>
        </li>
      </ul>

    </Box>
  )
}

export default SocialShare;
